import Dialog from "@components/Dialog"
import { Trans, useTranslation } from "react-i18next"

interface Props {
  onClose: () => void
  open: boolean
  emailFound?: boolean
}

export default function ForgotPasswordDialog({
  onClose,
  open,
  emailFound = true,
}: Props) {
  const { t } = useTranslation()
  const supportEmail = "support@filterly.app"

  if (!emailFound) {
    return (
      <Dialog onClose={onClose} open={open}>
        <div className="space-y-2">
          <h2 className="heading">
            {t("pages.account.forgotPassword.dialog.emailNotFoundTitle")}
          </h2>

          <p className="text-center">
            {t("pages.account.forgotPassword.dialog.emailNotFoundText")}
          </p>

          <a
            className="block text-center font-bold underline"
            href={`mailto:${supportEmail}`}
          >
            {supportEmail}
          </a>
        </div>
      </Dialog>
    )
  }

  return (
    <Dialog dismissible={false} onClose={onClose} open={open}>
      <div className="space-y-2">
        <h2 className="heading">
          {t("pages.account.forgotPassword.dialog.title")}
        </h2>

        <p className="text-center">
          <Trans
            components={{ bold: <span className="font-semibold" /> }}
            i18nKey="pages.account.forgotPassword.dialog.text"
          />
        </p>
      </div>
    </Dialog>
  )
}
